<template>
    <b-modal
      centered
      :hide-footer="true"
      modal-class="c-wrap"
      dialog-class="c-dialog"
      content-class="c-content"
      header-class="popup_header"
      body-class="c-body container"
      :visible="visible"
      @hide="onCancel"
    >
      <template #modal-header="{ close }" style="width: 100%; display: flex; justify-content: center">
        <p style="margin: auto auto auto 200px;" >{{community_idx == 0 ? $t("community.writing") : $t("community.post_edit")}}</p>
        <b-img class="mo_close_btn"  @click="onCancel" :src="require('../../../assets/image/ic_close2.png')" style="margin-right: 15px;"/>
      </template>
      <div class="leftright">
        <c-select
          style="width: 110px; height: 40px; font-family: KoreanGD15R;"
        :options="typeOptions"
        v-model="type"
        />
        <div class="center">
          <MdSingleCheckBox
            v-model="anony_state"
            variant="red"
            :label="$t('community.anony')"
          />
          <b-form-input type="text" readonly class="input input-text" style="text-align:center; width: 145px; height: 40px; background-color: #eeeeef; font-size: 16px; font-family: KoreanGD15R; margin-left: 5px;"
                        :value="phone"></b-form-input>
        </div>
      </div>
      <b-form-input type="text" class="input input-text-title" style="margin-top: 12px"
                    v-model="title"
                    :placeholder="$t('community.title_placeholder')"/>
      <b-form-textarea
        class="input input-text-title"
        style="margin-top: 12px; padding: 8px; height: 350px; font-size:17px; font-family: KoreanGD13R;"
        v-model="content"
        :placeholder="$t('community.content_placeholder')"/>
      <div class="leftright" style="margin-top: 18px">
        <b-button @click="add_file" class="attach_btn">{{$t("community.attachments")}}</b-button>
        <input @change="on_img_change()" type="file" name="file" accept="image/*" ref="img-input" style="display: none" />
<!--        <md-single-check-box-->
<!--          variant="red"-->
<!--          label-position="right"-->
<!--          label-color="red"-->
<!--          v-model="agreeHonest"-->
<!--          :label="$t('community.agree_honest_content_only_desc')"-->
<!--        />-->
      </div>
      <div v-for="(it ,idx) in image"
           @click="image = image.filter((it1, idx1) => {return idx != idx1})"
           class="input leftright"
           style="width: 100%; margin-top: 6px">
        <div style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">
          <b-img :src="require('../../../assets/image/ic_file.png')" style="height: 1em;"/>
          <span class="file_name">{{it.name}}</span>
        </div>
        <b-img :src="require('../../../assets/image/ic_close3@2x.png')" style="height: 1.3em;"/>
      </div>
      <div class="leftright" style="margin-top: 1em;">
        <div class="guide" style="width: 47%;">
          {{$t("community.made_guide")}}
        </div>
        <div>
          <div @click="change_push" :class="['custom-but', pushEditable?'':'disable']">
            <b-img :src="push_src" style="width: 1em;height: 1em;"/>
            <span>{{$t("community.push")}}</span>
          </div>
          <div @click="change_made" :class="['custom-but', madeEditable?'':'disable']" style="margin-left: 0.5em; width: 105px;">
            <b-img :src="made_src" style="width: 1em;height: 1em;"/>
            <span>{{$t("community.made_plus")}}</span>
          </div>
        </div>
      </div>
      <a  id="tooltip"  class="tooltip_btn">{{u.format($t("community.writing_possible"), this.writeLeft)}}</a>
      <b-tooltip
        custom-class="tooltip-body"
        placement="bottom"
        target="tooltip" triggers="click"
        variant="secondary"
      >
        <div class="tooltip-body" v-html="u.format($t('community.writing_limit_desc'), this.writeLimit)">
        </div>
      </b-tooltip>
      <div class="c-footer">
        <b-button  @click="onCancel" class="footer-btn" style="background: #cacbcd">{{$t('common.cancel')}}</b-button>
        <b-button @click="onComplete" variant="primary" class="footer-btn">{{$t('common.complete1')}}</b-button>
      </div>
    </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
const $u = require('util');

import MdSingleCheckBox from "../mf/MdSingleCheckBox";
import CSelect from "../CSelect";
// Utils.requestPost(
//   this.$c.API.Community.updateCommunity,
//   {
//     community_idx: this.id,
//     title: this.title,
//     content: this.content,
//     type: this.type,
//     phone: this.phone,
//     made: this.made,
//     push: this.push,
//     anony: this.anony,
//     image_url: this.images.map(it => {
//       return it.url
//     }).join(',')
//   }
// ).then(result => {
//   if (result.code == this.$c.API_RES_CODE.SUCCESS) {
//   } else {
//     Utils.toast(this, result.msg);
//   }
// });
export default {
  name: "communityCreatePopup",
  components: {MdSingleCheckBox, CSelect},
  props:["visible", "info", "onEdit"],
  data() {
    return {
      u:$u,
      Utils:Utils,
      community_idx: 0,
      type: this.$c.COMMUNITY_TYPE.SITE,
      title: '',
      phone: Utils.formatPhoneNumber(this.myinfo.phone),
      content: '',
      push: 'N',
      made: 'N',
      anony: 'N',
      anony_state: 'N',
      image: [],
      writeLeft: 3,
      writeLimit: 3,
      showTooltip: false,
      pushEditable: true,
      madeEditable: true,
      agreeHonest:false,
    }
  },
  methods:{
    onComplete(){
      if (this.phone == '') {
        Utils.toast(this, this.$t("community.phone_placeholder"));
        return;
      }
      if (this.title == '') {
        Utils.toast(this,this.$t("community.title_placeholder"));
        return;
      }
      if (this.content == '') {
        Utils.toast(this, this.$t("community.content_placeholder"));
        return;
      }
      console.log("anony_state = " + this.anony_state)
      // if (!this.agreeHonest) {
      //   Utils.toast(this, this.$t("community.agree_honest_content_only_placeholder"));
      //   return;
      // }
        Utils.requestPost(
          this.community_idx == 0 ? this.$c.API.Community.addCommunity : this.$c.API.Community.updateCommunity,
          {
            community_idx: this.community_idx,
            title: this.title,
            content: this.content,
            type: this.type,
            phone: this.phone,
            made: this.made,
            push: this.push,
            anony: this.anony_state,
            image_url: this.image.map(it => {
              return it.url
            }).join(','),
          },
        ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.onCancel();
              this.onEdit();
              // if (this.props.onSave) {
              //   this.props.onSave();
              // }
            } else {
              Utils.toast(this, result.msg);
            }
        });
    },

    getProfile() {
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          // this.myinfo.saveInfo();
          this.myinfo.loadInfo();
        } else {
        }
      });
    },

    initState(){
      console.log(this.myinfo.phone);
        this.community_idx =  0;
        this.type= this.$c.COMMUNITY_TYPE.SITE;
        this.title= '';
        this.phone= Utils.formatPhoneNumber(this.myinfo.phone);
        this.content= '';
        this.push= 'N';
        this.made= 'N';
        this.anony= 'N';
        this.anony_state= 'N';
        this.image= [];
        this.writeLeft= 3;
        this.writeLimit= 3;
        this.showTooltip= false;
        this.pushEditable= true;
        this.madeEditable= true;
        this.agreeHonest=false;
    },

    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
      if (this.info == null){
      } else {
        console.log("--------",this.info);
          this.community_idx = this.info.f_idx;
          this.type = this.info.f_type;
          this.title = this.info.f_title;
          this.phone = this.info.f_phone;
          this.content = this.info.f_content;
          this.push = this.info.f_push;
          this.made = this.info.f_made;
          this.anony = this.info.f_anony;
          this.anony_state= this.info.f_anony;
          this.pushEditable = this.info.f_push == 'N';
          this.madeEditable = this.info.f_made == 'N';
          this.image= this.info.f_image_url == '' ? [] : this.info.f_image_url.split(',').map(it => {
            return {
              name: it.substr(it.lastIndexOf('/') + 1),
              url: it
            };
          });
      }

      Utils.requestGet(this.$c.API.Community.getTodayWritingCount, {}).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.writeLeft = result.data.left;
            this.writeLimit = result.data.limit;
        } else {
          Utils.toast(result.msg);
        }
      });
      this.getProfile();
    },
    change_push(){
      if (!this.pushEditable) {
        return;
      }
      if (this.push == 'Y') {
        this.push = 'N';
        return;
      }
      Utils.showConfirm(this, '<p style="font-size: 22px;">'+this.$t("community.push_title")+'</p>'+
        '<p style="color: gray; font-size: 20px;">'+$u.format(this.$t("community.push_content"), this.myinfo.setting.community_push_point)+'</p>'+
        '<p style="color: #cf0000; text-decoration: underline; margin-bottom: 0; font-size: 2.px;">'+$u.format(this.$t("community.push_content1"), this.myinfo.pushCnt)+'</p>'
      ).then(value =>{
        if(value){
          this.push = 'Y';
        }
      });
    },
    change_made(){
      if (!this.madeEditable) {
        return;
      }
      if (this.made == 'Y') {
        this.made = 'N';
        return;
      }
      Utils.showConfirm(this, '<p style="font-size: 22px;">'+this.$t("community.made_title")+'</p>'+
        '<p style="color: gray; font-size: 20px;margin-bottom: 0;">'+$u.format(this.$t("community.made_content_1"), this.myinfo.setting.community_made_point)+'</p>'+
        '<p style="color: gray; font-size: 20px;">'+this.$t("community.made_content_2")+'</p>'+
        '<p style="color: #cf0000; text-decoration: underline; margin-bottom: 0; font-size: 20px;">'+$u.format(this.$t("community.made_content1"), this.myinfo.madeCnt)+'</p>'
      ).then(value =>{
        if(value){
          this.made = 'Y';
        }
      });
    },
    on_img_change(){
      var file = this.$refs['img-input'].files[0];
      var name = this.$refs['img-input'].value;
        name = name.substr(name.lastIndexOf('\\') + 1);
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
            this.image.push(
              {
                name : name,
                url : result.data.url
              });
        } else {
          Utils.toast(this,result.msg);
        }
      });
    },

    add_file(){
      this.$refs["img-input"].click();
    },

    onCancel(){
      this.initState();
      if(window.history.state == "forward")
        window.history.back();
    },

    replaceEnter(text){
      return text.replace(/\n/g, " ");
    },
     },
  watch: {
    visible: function (){
      if (this.visible)
        this.onShow();
    },
  },
  computed:{
    typeOptions(){
      var ret={};
      var temp = Object.entries(this.$c.COMMUNITY_CATEGORY1).filter(it => {
        return this.myinfo.isAdmin() ? true : it[1] != this.$t('community.notice')
      });
      for(let i =0 ; i< temp.length; i++){
        ret[temp[i][0]] = temp[i][1];
      }
      return ret;
    },
    made_src(){
      return this.made == 'Y'? require('../../../assets/image/ic_check_red_on@2x.png') :require('../../../assets/image/ic_check_red_off@2x.png');
    },
    push_src(){
      return this.push == 'Y'? require('../../../assets/image/ic_check_red_on@2x.png') :require('../../../assets/image/ic_check_red_off@2x.png');
    }
  },
  mounted() {
    this.myinfo.loadInfo();
    this.phone= Utils.formatPhoneNumber(this.myinfo.phone);
  },
  inject: ['eventBus'],


}
</script>

<style scoped lang="scss">
@import "../../../assets/css/vars";

.setting_btn {
  align-items: center;
  justify-content: center;
  background-color: $c_457fff;
  border-radius: 5px;
  width: 83px;
  height: 32px;
  font-size: $fs_12;
  padding: 0;
}

.add_btn {
  align-items: center;
  justify-content: center;
  background-color: #0840ba!important;
  border-radius: 4px;
  width: 83px;
  height: 32px;
  font-size: $fs_12;
  padding: 0;
  margin-top: 5px;
}


.disable{
  background-color: #ddddde!important;
}

::placeholder{
  color: #666666;
}

.c-footer{
  width: 480px;
  height: 50px;
  display: flex;
  //position: fixed;
  position: absolute;
  bottom: 0;
  left: -2px;
}

.footer-btn{
  background: $c_457fff;
  flex: 1;
  margin: 0;
  border-radius: 0;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.leftright{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header-title{
  font-size: $fs_20;
  font-family: $korean_gd_15_r;
  color: $text;
}

.center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.attach_btn {
  padding: 0;
  width: 70px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: #3d3d3e;
  border-radius: 3px;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
}
.file_name{
  color: #666666;
  font-size: $fs_16;
  font-family: $korean_gd_13_r;
  margin-left: 5px;
}

.guide{
  text-align: center;
  color: #cf0000;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
  margin:0 7px;
  line-height: 20px;
}

.custom-but{
  width:100px;
  height: 40px;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background: #cf0000;
  color:white;
  padding: 0.3em 10px;
  cursor:pointer;
}

.disable{
  background-color: #cacbcd;
}

.tooltip_btn{
  cursor: pointer;
  color:$primary;
  text-decoration: underline;
  float:right;
  margin-top: 1.5em;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
}
//.tooltip-body{
//  background: rgba(105, 105, 105, .9);
//}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/CommunityCreatePopup.vue